import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetFundraisingDates = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.investing.fundraising_dates],
    queryFn: () =>
      investingService.fundraisingDates().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
